import { BrowserRouter, Routes, Route } from 'react-router-dom';

/* Components */
import NavBar from './components/NavBar';

/* Pages */
import Meetings from './pages/Meetings'
import Home from './pages/Home'
import Documents from './pages/Documents';
import Survey from './pages/Survey';
import Comment from './pages/Comment';


function App() {
  const footerStyle = {
    backgroundColor: "#073553",
    paddingRight: "15px",
    paddingLeft: "15px",
  }
  const noUnderline = {
    textDecoration: "none"
  }
  return (
    <div className="App d-flex flex-column min-vh-100">
      <BrowserRouter basename="/kilgore">
      <NavBar/>
        <Routes>
            <Route path='/' element={<Home/>}/>
            <Route path='/meetings' element={<Meetings/>}/>
            <Route path='/documents' element={<Documents/>}/>
            <Route path='/survey' element={<Survey/>}/>
            <Route path='/comment' element={<Comment/>}/>
        </Routes>
      </BrowserRouter>
      <footer className="footer mt-auto py-3" style={footerStyle}>
        <div className="container  text-light text-white">
          <p className="float-end"><a href="#top" className="text-light text-white" style={noUnderline}>Back to top</a></p>
          <p>&copy; 2019 Freese and Nichols, Inc. | <a className="text-light text-white" target="_blank" rel="noreferrer" href="http://www.cityofkilgore.com/" style={noUnderline}>City of Kilgore, TX</a></p>
        </div>
      </footer>
    </div>
  );
}

export default App;
